module.exports = __webpack_public_path__ + "static/media/Background-House_Closed.46d414c2.svg";